













import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'
import Rate from '@/modules/shipping/model/Rate'
import { Prop } from 'vue-property-decorator';

@Component
export default class RateSelect extends Vue {
    @State(state => state.shipping.rates)
    public rates: Rate[]

    @Prop({type: Rate, default: null})
    public value: Rate | null

    @Prop({type: Boolean, default: false})
    public disabled: boolean
}
